<template>
    <b-table
        small
        bordered
        striped
        :items="items"
        :fields="fields"
        table-class="table-va-middle"
        empty-text="Não foi possível encontrar dados de temperaturas para essa data, não é possível gerar a visualização."
        class="shadow-sm"
        :busy="loading"
        show-empty
    >
        <template #table-busy>
            <div class="text-center my-5">
                <b-spinner class="align-middle mr-2" />
                <strong class="align-middle">Carregando termômetros...</strong>
            </div>
        </template>
        <template #empty="scope">
            <h4 class="my-5 text-center">{{ scope.emptyText }}</h4>
        </template>
    </b-table>
</template>

<script>
import api from "@/modules/julho_14/api";
import format from "@/utils/format";
import hasProperty from "@/utils/hasProperty";

const numberFormater = value => format(value);

export default {
    name: "ChosenConcreteTemperatureReadings",
    props: {
        epoch: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            temperatures: [],
            timer: null,
            loading: false
        };
    },
    computed: {
        items() {
            return this.temperatures.map((value, index) => ({
                name: "TC-" + `${index + 1}`.padStart(2, "0"),
                value
            }));
        },
        fields() {
            return [
                {
                    key: "name",
                    label: "Termômetro",
                    thClass: "text-center font-weight-normal",
                    tdClass: "text-center"
                },
                {
                    key: "value",
                    label: "Temperatura (°C)",
                    thClass: "text-center font-weight-normal",
                    tdClass: "text-center",
                    formatter: numberFormater
                }
            ];
        }
    },
    watch: {
        epoch: {
            immediate: true,
            handler() {
                clearInterval(this.timer);
                this.loading = true;
                this.timer = setTimeout(async () => {
                    await this.updateTemperatures();
                    this.loading = false;
                }, 1000);
            }
        }
    },
    created() {
        this.fetchedTemperatures = {};
    },
    methods: {
        async updateTemperatures() {
            if (!hasProperty(this.fetchedTemperatures, this.epoch)) {
                const {
                    data
                } = await api.concreteTemperatureThermometers.readingsByEpoch(
                    this.epoch
                );
                this.fetchedTemperatures[this.epoch] = data;
            }

            this.temperatures = [...this.fetchedTemperatures[this.epoch]];
        }
    }
};
</script>
